import debounce from "./debounce";
import throttle from "./throttle";
import throttleHaveParam from "./throttleHaveParam";
import draggable from "./draggable";
import lazyLoad from "./lazyLoad";
// 自定义指令
const directives = {
  debounce,
  throttle,
  throttleHaveParam,
  draggable,
  lazyLoad,
};

export default {
  install(Vue) {
    Object.keys(directives).forEach((key) => {
      Vue.directive(key, directives[key]);
    });
  },
};
